/*
 * File: form-string.ts
 * File Created: 2024-01-11 01:28:50
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-26 01:27:04
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import {
    IFormComponentAttr,
    IFormValidateResult,
    createRequiredValidator,
} from "../../core/lib/core";
import { PropInnateSync } from "@root/core/vue-props";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";

@Component
export default class FormCheck extends BaseFormComponent {
    @PropInnateSync("value", { type: [String, Number, Array], required: false })
    innateValue!: string | number | string[] | number[] | null;

    /// private helpers
    // required validation for check
    @makeRequiredValidator({
        /// handle both "single" and "multiple" case.
        validator: (o) =>
            !(o.value == null || (Array.isArray(o.value) && o.value.length == 0)),
    })
    defaultRequired() {
        return undefined;
    }
}
